import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import * as yup from 'yup';

import EditFooter from '@root/components/DocumentView/components/EditFooter';
import useTextSelect from '@root/utils/hooks/useTextSelect';
import { handleDocumentEditorTextSelect } from '@root/utils/file.utils';

const validationSchema = yup.object({
  subject: yup
    .string()
    .required('Subject is required'),
  body: yup
    .string()
    .required('body is required'),
});

const useStyles = makeStyles((theme) => ({
  fieldsWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    marginBottom: theme.spacing(3),
  },
}));

const SalesEmailEditor = ({
  content: initialContent,
  onSave,
  onCancelEdit,
  children,
  onTextSelect,
}) => {
  const classes = useStyles();

  const subjectRef = React.useRef();
  const emailBodyRef = React.useRef();

  const { subject, emailBody } = initialContent;

  const formik = useFormik({
    initialValues: {
      subject,
      emailBody,
    },
    validationSchema,
    onSubmit: async ({ content: newContent }) => {
      await onSave({ content: newContent });
    },
  });

  useTextSelect((selection) => {
    const fieldRefList = [{
      ref: subjectRef.current,
      field: 'subject',
    }, {
      ref: emailBodyRef.current,
      field: 'emailBody',
    }];

    handleDocumentEditorTextSelect({
      selection,
      fieldRefList,
      onTextSelect,
      content: formik.values,
      setFieldValue: formik.setFieldValue,
    });
  });

  const save = async () => {
    const newContent = {
      subject: formik.values.subject,
      emailBody: formik.values.emailBody,
    };
    await onSave({ content: newContent });
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.fieldsWrap}>
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="subject"
          name="subject"
          label="Subject"
          value={formik.values.subject}
          onChange={formik.handleChange}
          error={formik.touched.subject && Boolean(formik.errors.subject)}
          helperText={formik.touched.subject && formik.errors.subject}
          variant="outlined"
          className={classes.input}
          ref={subjectRef}
        />
        <TextField
          InputLabelProps={{ shrink: true }}
          id="emailBody"
          name="emailBody"
          label="Body"
          value={formik.values.emailBody}
          onChange={formik.handleChange}
          error={formik.touched.emailBody && Boolean(formik.errors.emailBody)}
          helperText={formik.touched.emailBody && formik.errors.emailBody}
          variant="outlined"
          multiline
          className={classes.input}
          ref={emailBodyRef}
        />
      </div>
      {children}
      <EditFooter
        onCancelEdit={onCancelEdit}
        onSave={save}
      />
    </form>
  );
};

export default SalesEmailEditor;
